<template>
  <v-container>
    <v-row>
      <v-col cols="12" align="center">
        <h1>{{ $t('common.get-in-touch')}}</h1>
        <p>{{ $t('contact-us.cta')}}</p>
        <v-btn outlined color="primary" dark id="open_intercom_chat">
          {{ $t('common.contact-us')}}
        </v-btn>
      </v-col>
      <v-row>
        <v-col cols="12" md="6">
          <v-card flat>
            <v-card-title>
              {{ $t('contact-us.australia')}}
            </v-card-title>
            <v-card-text>
              <p>100 Harris Street</p>
              <p>Pyrmont, NSW 2009, <b>{{ $t('contact-us.australia')}}</b></p>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.8236422730206!2d151.19155161595285!3d-33.8684356264728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12ae3696be7fbf%3A0x7784d9732d4ec158!2s100%20Harris%20St%2C%20Pyrmont%20NSW%202009!5e0!3m2!1sen!2sau!4v1580969821135!5m2!1sen!2sau" width="100%" height="200" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card flat>
            <v-card-title>
              {{ $t('contact-us.china')}}
            </v-card-title>
            <v-card-text>
              <p>{{ $t('contact-us.block-a')}}</p>
              <p>
                {{ $t('contact-us.taoyuan-rd')}}, {{ $t('contact-us.shenzhen')}} 518060,
                <b>{{ $t('contact-us.china')}}</b>
              </p>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.2437548235926!2d113.92458395114798!3d22.53253994004434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403ee6c618b712d%3A0xfb37bf1ef7d98ae1!2s8%20Taoyuan%20Rd%2C%20Nan%20Tou%2C%20Nanshan%20Qu%2C%20Shenzhen%20Shi%2C%20Guangdong%20Sheng%2C%20China%2C%20518060!5e0!3m2!1sen!2sau!4v1580970087621!5m2!1sen!2sau" width="100%" height="200" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ContactUs',
};
</script>

<style scoped>

</style>
